/**
 * Example Media URLs for WhatsApp Business Template Headers
 * These URLs are used as examples when creating templates with media headers
 */

export const WHATSAPP_MEDIA_EXAMPLE_URLS = {
    IMAGE: "https://www.w3.org/MarkUp/Test/xhtml-print/20050519/tests/jpeg420exif.jpg",
    VIDEO: "https://samplelib.com/lib/preview/mp4/sample-5s.mp4",
    DOCUMENT: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
};

export default WHATSAPP_MEDIA_EXAMPLE_URLS;

